import { Component, Vue } from 'vue-property-decorator'
import BasketErrorSvg from '~/assets/svg/basket-error.svg?inline'
import loc from '~/utils/loc'
import s from '~/utils/s'
import { MetrikaLocalCodes } from '~/types/api/MetrikaCode'

@Component
export default class BasketResult extends Vue {
  get thereIsAvailableItems () {
    return !!s(this.$store).basket.items.find(e => e.product.available > 0)
  }

  openPopup (event: MouseEvent) {
    event.stopPropagation()
    s(this.$store).general.showPopup('OrderAuthPopup')
  }

  freeDelivery () {
    const cond = s(this.$store).regions.currentRegionSectionDeliveryConditions

    return (
      cond.deliveryAvailable &&
      cond.recommendDeliveryUpTo! &&
      cond.recommendDeliveryUpTo! >=
      s(this.$store).basket.price
    )
  }

  renderButtonMakeOrder () {
    if (this.thereIsAvailableItems) {
      if (s(this.$store).auth.isAuth) {
        return (
          <div class="basket-result__submit-wrapper">
            {<nuxt-link to={loc(this.$store, { name: 'order' })}
              class="button-text" {...{
                nativeOn: {
                  click: async () => this.$reachGoal(await s(this.$store).seo.getMetrikaCode(MetrikaLocalCodes.MAKE_ORDER))
                }
              }}>
              Оформить заказ
            </nuxt-link>}
          </div>
        )
      } else {
        return (
          <div class="basket-result__submit-wrapper">
            <div class="button-text" onClick={this.openPopup}>
              Войти и оформить заказ
            </div>
          </div>
        )
      }
    } else {
      return (
        <div class="basket-result__submit-wrapper">
          <a class="button-text not-available" disabled>Оформить заказ</a>
        </div>
      )
    }
  }

  getFreeDelivery () {
    const cond = s(this.$store).regions.currentRegionSectionDeliveryConditions
    return (
      cond.recommendDeliveryUpTo -
      s(this.$store).basket.price
    ).toFixed(2)
  }

  render () {
    return (
      <div class="basket-result">
        <div class="basket-result__prices">
          <div class="basket-result__prices-name">
            Товары ({s(this.$store).basket.count} шт.)
          </div>
          <div class="basket-result__prices-value">
            {s(this.$store).basket.basePrice} ₽
          </div>
        </div>
        <div class="basket-result__prices">
          <div class="basket-result__prices-name">
            Скидка
          </div>
          <div class="basket-result__prices-value basket-result__prices-value_discount">
            {s(this.$store).basket.discountPrice} ₽
          </div>
        </div>
        {this.freeDelivery() &&
          !s(this.$store).basket.containsPrescription && (
          <div class="basket-result__prices">
            <div class="basket-result__prices-name">
                До бесплатной доставки
            </div>
            <div class="basket-result__prices-value">
              {this.getFreeDelivery()} ₽
            </div>
          </div>
        )}
        <div class="basket-result__prices basket-result__prices_summ">
          <div class="basket-result__prices-name">
            Итого:
          </div>
          <div class="basket-result__prices-value basket-result__prices-value_summ">
            {s(this.$store).basket.price} ₽
          </div>
        </div>
        {this.renderButtonMakeOrder()}
        <div class="basket-result__description-wrapper">
          <div class="basket-result__description-icon">
            <BasketErrorSvg />
          </div>
          <div class="basket-result__description">
            <div class="basket-result__description-common">
              <p>Рецептурные и ветеринарные препараты доставляются до пункта выдачи</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
